/**
 * Bandeja in-app de notificaciones del user actual.
 */

import { api } from "./client";
import type { NotificationItem, UnreadCount } from "./types";

export async function listNotifications(opts?: {
  unreadOnly?: boolean;
  limit?: number;
  beforeId?: number;
}): Promise<NotificationItem[]> {
  const params: Record<string, unknown> = {};
  if (opts?.unreadOnly) params.unread_only = true;
  if (opts?.limit) params.limit = opts.limit;
  if (opts?.beforeId) params.before_id = opts.beforeId;
  const res = await api.post<NotificationItem[]>("/me/notifications/list", { ...params });
  return res.data;
}

export async function getUnreadCount(): Promise<UnreadCount> {
  const res = await api.get<UnreadCount>("/me/notifications/count");
  return res.data;
}

export async function markNotificationRead(id: number): Promise<NotificationItem> {
  const res = await api.post<NotificationItem>("/me/notifications/read", { notif_id: id });
  return res.data;
}

export async function markAllNotificationsRead(): Promise<UnreadCount> {
  const res = await api.post<UnreadCount>("/me/notifications/read-all");
  return res.data;
}
